/*
 * @Author: your name
 * @Date: 2021-04-24 15:34:56
 * @LastEditTime: 2021-06-08 23:55:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\store\navList.js
 */
// channels 的仓库数据
import { basic_info } from '@/api/basicAPI';

export default {
    // 开启命名空间
    namespaced: true,
    state: {
        goods_list: [],     // 商品列表
        classify_list: [],  // 分裂列表
        child_list: [],     // 
        basic_info: [],     // 网站基础信息
        isLoading: false,
    },
    mutations: {
        // 仓库数据改动必须通过mutation,没有例外,再mutations里面配置所有变化，每种变化都是一个函数
        // state 原来的状态
        // payload 负荷，有的话有且只有一个，可以是任何一个
        // mutation 里面不能有副作用操作，异步，改动或使用外部数据等。
        // 用this.$store.commit(mutations里的函数,payload修改的值)来调用mutation 命名空间内容部的话，直接用函数，命名空间外部的话用 命名空间名/函数
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setGoodsList(state, payload) {
            state.goods_list = payload;
        },
        setClassifyList(state, payload) {
            state.classify_list = payload;
        },
        setChildList(state, payload) {
            state.child_list = payload;
        },
        setBasicInfo(state, payload) {
            state.basic_info = payload;
        }
    },
    actions: {
        // 副作用操作的函数在这里
        // 函数参数：function(context,payload)
        // context 相当于是仓库对象
        // payload 负荷,可以没有
        // 触发action 使用dispatch(action里的函数,payload修改的值) 例如 this.$store.dispatch('');命名空间内容部的话，直接用函数，命名空间外部的话用 命名空间名/函数
        async fetchBasicInfo(context) {
            // 注意必须通过mutation修改仓库的数据
            context.commit('setIsLoading', true);
            var result = await basic_info();
            context.commit('setGoodsList', result.goods_list);
            context.commit('setClassifyList', result.classify_list);
            context.commit('setChildList', result.child_list);
            context.commit('setBasicInfo', result.basic_info);
            context.commit('setIsLoading', false);
        }
    }
};